import { CO2_LFL_SLUG, FilterType, getFarmersFilterInputs, getFarmersFilters, MILK_MONEY_ACCOUNT_SLUG } from '~/Constants'

export function getFarmerFilterValues(hasAnyTradingSlot, hasMilkMoneyModule, hasCo2Module) {
  const farmersFilters = getFarmersFilters()
  const farmerFiltersFirstElements = farmersFilters.slice(0, 2)
  const filterValues = []
  filterValues.push(...farmerFiltersFirstElements)

  if (hasAnyTradingSlot) {
    const farmersFilterInputs = getFarmersFilterInputs()
    filterValues.push(...farmersFilterInputs)
  }

  if(hasCo2Module) {
    const periodIndex = farmersFilters.findIndex(filter => filter.key === 'periods')
    filterValues.push(farmersFilters[periodIndex])
  }

  const milkTypeIndex = farmersFilters.findIndex(filter => filter.key === 'milkTypeId')
  const stateIndex = farmersFilters.findIndex(filter => filter.key === 'stateId')
  
  filterValues.push(
    ...[
      farmersFilters[milkTypeIndex],
      farmersFilters[stateIndex]
    ])

  return filterValues
}

export function filtersBasedOnModules(
  hasAnyTradingSlot: boolean,
  hasMilkMoneyModule: boolean,
  hasCo2Module: boolean,
  filters: FilterType[]): FilterType[] {
  let tempFilters = filters || []
  const tradingSlotFilterKeys = getFarmersFilterInputs().map(filter => filter.key)

  if(!hasAnyTradingSlot) {
    tempFilters = filters.filter(filter => !tradingSlotFilterKeys.find(keyFilter => keyFilter === filter.key))
  }

  if(!hasMilkMoneyModule) {
    tempFilters = tempFilters.filter(filter => filter?.moduleSlug !== MILK_MONEY_ACCOUNT_SLUG)
  }

  if (!hasCo2Module) {
    tempFilters = tempFilters.filter(filter => filter?.moduleSlug !== CO2_LFL_SLUG)
  }

  return tempFilters
}